/**
 * The fixed brightness multiplier applied to the camera stream when the brightness
 * adjustment is enabled. A value of 1 leaves the image unchanged, while this value
 * brightens it. Tuned to approach Google Meet's "adjust brightness" strength.
 */
export const BRIGHTNESS_LEVEL = 1.6;
/**
 * The maximum brightness multiplier the adaptive auto-exposure is allowed to reach on very
 * dark scenes. Capped to avoid amplifying sensor noise into a grainy image.
 */
export const ADAPTIVE_MAX_BOOST = 3;
/**
 * The minimum brightness multiplier applied whenever the adjustment is enabled. The target
 * users are always in low light, so we keep a guaranteed baseline lift (never weaker than the
 * previous fixed boost) and let the adaptive logic push higher as the scene gets darker.
 */
export const ADAPTIVE_MIN_BOOST = 1.9;
/**
 * The target mean luminance (0..1) the adaptive auto-exposure aims for. The boost is chosen
 * so the measured average luminance of the subject moves towards this value. Set fairly high
 * so the result clearly "whitens", matching the strength requested versus Google Meet.
 */
export const ADAPTIVE_TARGET_LUMA = 0.9;
/**
 * Temporal smoothing factor (0..1) applied to the brightness multiplier each frame. Lower
 * values ramp more slowly, preventing visible flicker/pumping as the scene changes.
 */
export const ADAPTIVE_SMOOTHING = 0.08;
/**
 * How often (in frames) the frame luminance is re-measured. Measuring every frame is
 * unnecessary and costs a getImageData readback, so it is throttled.
 */
export const ADAPTIVE_SAMPLE_INTERVAL = 8;
